exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-data[data-v-d12f285c], .base-view .view-group .view-data[data-v-d12f285c] {\n  white-space: pre-line;\n}", ""]);

// exports
